import type { SearchPersona, SearchPersonaSource } from '@/app/common/filters/quickFilters/searchPersona.ts';
import { TRIP_STYLE, TRAVELLER_TYPE, getSearchPersona } from '@/app/common/filters/quickFilters/searchPersona.ts';
import type { FilterFlags } from '@/app/common/filters/core/filterFlags.ts';
import { smartFiltersEnabled } from '@/app/common/filters/core/filterFlags.ts';
import type { QuickFilter } from '@/app/common/filters/quickFilters/quickFilterCatalogue.ts';
import { QUICK_FILTER, QUICK_FILTER_CATALOGUE } from '@/app/common/filters/quickFilters/quickFilterCatalogue.ts';

// Offered on every search, behind the search-aware chips.
const ALWAYS_QUICK_FILTER_IDS: QUICK_FILTER[] = [QUICK_FILTER.STARS_4_TO_5, QUICK_FILTER.RATING_4_PLUS];

const PERSONA_QUICK_FILTER_IDS: Record<`${TRAVELLER_TYPE}:${TRIP_STYLE}`, QUICK_FILTER[]> = {
  [`${TRAVELLER_TYPE.SOLO}:${TRIP_STYLE.BEACH}`]: [
    QUICK_FILTER.FULL_BOARD,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
    QUICK_FILTER.AIR_CONDITIONING,
  ],
  [`${TRAVELLER_TYPE.SOLO}:${TRIP_STYLE.CITY}`]: [
    QUICK_FILTER.BREAKFAST,
    QUICK_FILTER.RESTAURANT_BAR,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
  ],
  [`${TRAVELLER_TYPE.COUPLE}:${TRIP_STYLE.BEACH}`]: [
    QUICK_FILTER.ALL_INCLUSIVE,
    QUICK_FILTER.RESTAURANT_BAR,
    QUICK_FILTER.SPA,
  ],
  [`${TRAVELLER_TYPE.COUPLE}:${TRIP_STYLE.CITY}`]: [
    QUICK_FILTER.RESTAURANT_BAR,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
    QUICK_FILTER.PARKING,
  ],
  [`${TRAVELLER_TYPE.GROUP}:${TRIP_STYLE.BEACH}`]: [
    QUICK_FILTER.ALL_INCLUSIVE,
    QUICK_FILTER.RESTAURANT_BAR,
    QUICK_FILTER.PARKING,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
  ],
  [`${TRAVELLER_TYPE.GROUP}:${TRIP_STYLE.CITY}`]: [
    QUICK_FILTER.RESTAURANT_BAR,
    QUICK_FILTER.PARKING,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
  ],
  [`${TRAVELLER_TYPE.FAMILY}:${TRIP_STYLE.BEACH}`]: [
    QUICK_FILTER.ALL_INCLUSIVE,
    QUICK_FILTER.KIDS_CLUB,
    QUICK_FILTER.SWIMMING_POOL,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
  ],
  [`${TRAVELLER_TYPE.FAMILY}:${TRIP_STYLE.CITY}`]: [
    QUICK_FILTER.BREAKFAST,
    QUICK_FILTER.ACCESSIBILITY,
    QUICK_FILTER.HIGH_SPEED_INTERNET,
    QUICK_FILTER.PARKING,
  ],
};

export const getPersonaQuickFilters = ({ travellerType, tripStyle }: SearchPersona): QuickFilter[] => {
  const ids = tripStyle ? PERSONA_QUICK_FILTER_IDS[`${travellerType}:${tripStyle}`] : [];

  return [...ids, ...ALWAYS_QUICK_FILTER_IDS].map((id) => QUICK_FILTER_CATALOGUE[id]);
};

export const getSmartQuickFilters = ({
  config,
  ...source
}: SearchPersonaSource & { config?: FilterFlags }): QuickFilter[] =>
  smartFiltersEnabled(config) ? getPersonaQuickFilters(getSearchPersona(source)) : [];
